<template>
  <div class="call-request-modal">
    <h3 class="call-request-modal__title">
      Записаться на экскурсию
    </h3>

    <div class="call-request-modal__caption">
      <p>Мы уже забронировали для вас место! Осталось только выбрать удобное время.</p>
      <p>Оставьте свои данные, и наши эксперты свяжутся с вами в ближайшее время.</p>
    </div>

    <form ref="Form"
      class="call-request-modal__form"
      @submit.prevent="submitForm">
      <input type="hidden" name="form_name" value="Записатсья на экскурсию">
      <FormInput :key="updateKey"
        v-model="form.name"
        class="call-request-modal__input"
        :class="{ _error: invalid && !form.name }"
        name="name"
        placeholder="Ваше имя*"
        @blur="onInput" />
      <div class="call-request-modal__row">
      <FormInput :key="phoneKey"
          v-model="form.phone"
          class="call-request-modal__input"
          type="tel"
          name="phone"
          placeholder="Контактный телефон*"
          :class="{ _error: invalid && !form.phone }"
          @blur="onPhoneInput" />
      </div>
      <div class="call-request-modal__row">
        <FormCheck v-model="formIsCheck"
          :class="{ _error: invalid && !checkIsValid }"
          class="call-request-modal__check"
          @click="onChange">
          Согласие на обработку
          <a href="/politika"
            class="call-request-modal__agreement"
            target="_blank">персональных данных </a>
        </FormCheck>
        <AppButton class="call-request-modal__action"
          :to-send="true"
          :sending="sending">
          Заказать
        </AppButton>
      </div>
      <!--   <div v-if="invalid" class="_invalid">Заполните все поля!</div> -->
    </form>
  </div>
</template>

<script>
import FormInput from "@/components/form/FormInput.vue";
import FormCheck from "@/components/form/FormCheck.vue";
import AppButton from "@/components/ui/AppButton.vue";

export default {
  name: "CallPopupModal",
  components: { FormCheck, FormInput, AppButton },

  props: {
    nameIsValid: {
      type: String,
      default: null,
    },
    phoneIsValid: {
      type: String,
      default: null,
    },
    checkIsValid: {
      type: Boolean, 
      default: null,
    },
  },

  data() {
    return {
      form: {
        page: window.location.href,
      },
      invalid: false,
      errors: [],
      formIsCheck: false,
      updateKey: 0,
      phoneKey: 0,
      sending: false,
    };
  },

  methods: {
    isValid() {
      const nameIsValid = !!this.form.name;
      const phoneIsValid = !!this.form.phone;
      const checkIsValid = !!this.formIsCheck;

      if (nameIsValid && phoneIsValid && checkIsValid) return true;
    },

    onChange() {
      this.formIsCheck = !this.formIsCheck;
    },

    onInput(event) {
      const inputValue = event.target.value;
      const inputLength = inputValue.length;

      if (inputLength < 1) {
        this.form.name = null;
      }
    },

    onPhoneInput(event) {
      const inputValue = event.target.value;
      const inputLength = inputValue.length;

      if (inputLength < 18) {
        this.phoneKey += 1;
        this.form.phone = null;
      }
    },

    submitForm() {
      if (this.isValid()) {
        this.errors = [];
        this.invalid = false;
        this.sending = true;
        this.axios
          .post("/api/sendPopupForm", this.form)
          .then((response) => {
            if (response.status) {
              let form = this.form;

              form = {};

              Object.keys(form).forEach(function (key) {
                form[key] = "";
              });

              this.formIsCheck = false;
              this.sending = false;
              this.updateKeyValue();
              this.phoneKey += 1;
              this.form.phone = null;
              this.form.name = null;
              this.$emit("form-success-popup");
            }
          })
          .catch((error) => {
            this.sending = false;
            /* this.errors = error.response.data.errors; */
          });
      } else {
        this.invalid = true;
      }
    },
    
    updateKeyValue() {
      this.updateKey += 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.call-request-modal {
  $that: &;

  padding: 70px 56px 56px;

  @include tablet {
    padding: 58px;
  }

  @include phone {
    padding: 38px 28px;
  }

  @include phone {
    padding: 28px 16px;
  }

  &__title {
    font-weight: 700;
    font-size: 36px;
    line-height: 36px;
    color: #141c1a;
    margin-bottom: 34px;

    @include phone {
      font-size: 24px;
      line-height: 120%;
      margin-bottom: 30px;
    }
  }

  &__caption {
    color: #141c1a;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 34px;
  }

  &__input {
    margin-bottom: 16px;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 10px;

    @include phone {
      flex-direction: column;
    }

    &>* {
      flex: 0 1 50%;
    }
  }

  &__action {
    margin-left: auto;
    flex-shrink: 0;
    margin-top: 8px;
    max-width: 210px;
  }

  &__check {
    width: 100%;
    margin-top: 16px;
    font-size: 14px;
    margin-right: 60px;
    white-space: nowrap;
  }

  ._invalid {
    color: red;
    padding-top: 8px;
  }

  &__agreement {
    text-decoration: underline;
  }
}

@media screen and (max-width: 640px) {
  .call-request-modal__check
  {
    margin-left: 60px;
  }
}

@media screen and (min-width: 1000px) {
  .call-request-modal__caption
  {
    min-width: 600px;
  }
}
</style>
